import { inject, Injectable } from "@angular/core";
import type { FilterSelections, StoredColumnFilterState } from "../../filter.types";
import { VIEW_TYPE } from "../../filter.tokens";

@Injectable()
export class FilterPersistence {
    private static readonly VERSION = 1;

    private readonly viewType = inject(VIEW_TYPE);

    private persistenceId = "";

    public setId(persistenceId: string): void {
        this.persistenceId = persistenceId;
    }

    public load(): FilterSelections | undefined {
        const rawState = localStorage.getItem(this.getKey());
        if (rawState === null) return undefined;

        let parsedState: unknown;
        try {
            parsedState = JSON.parse(rawState);
            if (!this.isStoredState(parsedState)) return {};
        } catch {
            return {};
        }

        return parsedState.selections;
    }

    public save(selections: FilterSelections): void {
        const state: StoredColumnFilterState = {
            version: FilterPersistence.VERSION,
            selections,
        };

        localStorage.setItem(this.getKey(), JSON.stringify(state));
    }

    public clear(): void {
        localStorage.removeItem(this.getKey());
    }

    public getKey(): string {
        return `${this.persistenceId}_${this.viewType}`;
    }

    private isStoredState(value: unknown): value is StoredColumnFilterState {
        if (!value || typeof value !== "object") {
            return false;
        }

        const state = value as Partial<StoredColumnFilterState>;
        return state.version === FilterPersistence.VERSION && !!state.selections && typeof state.selections === "object";
    }
}
